<template>
    <div v-if="loader" style="height: 200px; line-height: 250px;">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
    </div>
    <div v-else-if="!loader" class="ma-8">
        <div class="title-cadre mb-10">
            <div class="title">
                {{ $t('clients.validationTab.clientsStatus') }}
            </div>
        </div>
        <div class="timelineStatus my-2">
            <StatusButton disableIcon :title="statusTitle(0)"
                :color="Status > 0 ? '#00CBA0' : Status == 0 ? '#FF8934' : '#C5CDD4'"
                :style="Status < 0 ? 'color:black' : ''">
                <template v-slot:icon>
                    <svg v-if="Status > 1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="Status == 1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                </template>
            </StatusButton>
            <v-sheet elevation="0" :height="5" :width="120"
                :color="Status > 1 ? '#00CBA0' : Status == 1 ? '#FF8934' : '#C5CDD4'"
                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(1)"
                :color="Status > 1 ? '#00CBA0' : Status == 1 ? '#FF8934' : '#C5CDD4'"
                :style="Status < 1 ? 'color:black' : ''">
                <template v-slot:icon>
                    <svg v-if="Status > 1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="Status == 1" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>
            <v-sheet elevation="0" :height="5" :width="120"
                :color="Status > 2 ? '#00CBA0' : Status == 2 ? '#FF8934' : '#C5CDD4'"
                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(2)"
                :color="Status > 2 ? '#00CBA0' : Status == 2 ? '#FF8934' : '#C5CDD4'"
                :style="Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                    <svg v-if="Status > 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="Status == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>
            <v-sheet elevation="0" :height="5" :width="120"
                :color="Status <= 2 ? '#C5CDD4' : Status == 3 ? '#00CBA0' : 'red'"
                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon
                :title="Status == 3 ? statusTitle(3) : Status < 3 ? `${$t('clients.statusList.validatedCustomer')} / ${this.$t('clients.statusList.rejected')}` : statusTitle(4)"
                :color="Status <= 2 ? '#C5CDD4' : Status == 3 ? '#00CBA0' : 'red'"
                :style="Status < 3 ? 'color:black' : ''">
                <template v-slot:icon>
                    <svg v-if="Status == 3 || Status == 4" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>
        </div>
        <div v-if="!ShowChangeStatusValues.includes(Customer.accountStatus)" class="my-8 row justify-content-center">
            <div class="col-6 justify-content-center">
                <div class="row justify-content-center">
                    <div class="col-auto">
                        <genericBtnComponent backgroundColor="orange" @click="dialogCommentToCorrect = true"
                            :Title="$t('actions.toCorrect')" width="150"/>
                    </div>
                    <div class="col-auto">
                        <genericBtnComponent backgroundColor="#114EF7" @click="dialogValidation = true"
                            :Title="$t('clients.validationTab.valideBtn')" width="150">
                            <template v-slot:logo>
                                <svg class="mr-2"  width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                            </template>
                        </genericBtnComponent>
                    </div>
                    <div class="col-auto">
                        <genericBtnComponent backgroundColor="#F25C5C" @click="dialogCommentRefuse = true"
                            :Title="$t('clients.validationTab.refuseBtn')" width="150" >
                            <template v-slot:logo>
                                <svg class="mr-2" width="18" height="18" viewBox="0 0 16 16"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z"
                                        fill="white" />
                                </svg>
                            </template>
                        </genericBtnComponent>
                    </div>
                </div>
            </div>
        </div>
        <div class="title-cadre mt-10 mb-4" v-if="TraceValidationList">
            <div class="title">
                {{ $t('suppliers.validationTab.validationHistory') }}
            </div>
        </div>
        <v-table fixed-header height="200px" v-if="TraceValidationList">
            <thead>
                <tr>
                    <th class="text-center">
                        {{ $t('clients.validationTab.StatusChangedDate') }}
                    </th>
                    <th class="text-center">
                        {{ $t('clients.validationTab.ChangedBy') }}
                    </th>
                    <th class="text-center">
                        {{ $t('clients.validationTab.lastStatus') }}
                    </th>
                    <th class="text-center">
                        {{ $t('clients.validationTab.status') }}
                    </th>
                    <th class="text-center">
                        {{ $t('clients.validationTab.commentaire') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in TraceValidationList" :key="item.validationDate">
                    <td style="text-wrap: nowrap">{{ formattedDateTime(item) }}</td>
                    <td style="text-wrap: nowrap">
                        <v-list-item-title v-text="item.validatedBy.fullName"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.validatedBy.email"></v-list-item-subtitle>
                    </td>
                    <td>
                        <StatusButton disableIcon :title="statusTitle(item.lastStatus)"
                            :color="getStatusColor(item.lastStatus)" style="zoom: 0.9;">
                            <template v-slot:icon>
                                <svg v-if="item.lastStatus == 0" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M18.6695 2H16.7695C14.5895 2 13.4395 3.15 13.4395 5.33V7.23C13.4395 9.41 14.5895 10.56 16.7695 10.56H18.6695C20.8495 10.56 21.9995 9.41 21.9995 7.23V5.33C21.9995 3.15 20.8495 2 18.6695 2Z"
                                        fill="#FFFFFF" />
                                    <path opacity="0.4"
                                        d="M7.24 13.4302H5.34C3.15 13.4302 2 14.5802 2 16.7602V18.6602C2 20.8502 3.15 22.0002 5.33 22.0002H7.23C9.41 22.0002 10.56 20.8502 10.56 18.6702V16.7702C10.57 14.5802 9.42 13.4302 7.24 13.4302Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M17.7099 21.9999C20.0792 21.9999 21.9999 20.0792 21.9999 17.7099C21.9999 15.3406 20.0792 13.4199 17.7099 13.4199C15.3406 13.4199 13.4199 15.3406 13.4199 17.7099C13.4199 20.0792 15.3406 21.9999 17.7099 21.9999Z"
                                        fill="#FFFFFF" />
                                </svg>
                                <svg v-else-if="item.lastStatus == 1 || item.lastStatus == 2" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                                        fill="#FFFFFF" />
                                </svg>
                                <svg v-else-if="item.lastStatus == 3" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                                <svg v-else-if="item.lastStatus == 4" width="16" height="16" viewBox="0 0 16 16"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z"
                                        fill="white" />
                                </svg>
                            </template>
                        </StatusButton>
                    </td>
                    <td>
                        <StatusButton disableIcon :title="statusTitle(item.status)" :color="getStatusColor(item.status)"
                            style="zoom: 0.9;">
                            <template v-slot:icon>
                                <svg v-if="item.status == 0" width="10" height="10" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M18.6695 2H16.7695C14.5895 2 13.4395 3.15 13.4395 5.33V7.23C13.4395 9.41 14.5895 10.56 16.7695 10.56H18.6695C20.8495 10.56 21.9995 9.41 21.9995 7.23V5.33C21.9995 3.15 20.8495 2 18.6695 2Z"
                                        fill="#FFFFFF" />
                                    <path opacity="0.4"
                                        d="M7.24 13.4302H5.34C3.15 13.4302 2 14.5802 2 16.7602V18.6602C2 20.8502 3.15 22.0002 5.33 22.0002H7.23C9.41 22.0002 10.56 20.8502 10.56 18.6702V16.7702C10.57 14.5802 9.42 13.4302 7.24 13.4302Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M17.7099 21.9999C20.0792 21.9999 21.9999 20.0792 21.9999 17.7099C21.9999 15.3406 20.0792 13.4199 17.7099 13.4199C15.3406 13.4199 13.4199 15.3406 13.4199 17.7099C13.4199 20.0792 15.3406 21.9999 17.7099 21.9999Z"
                                        fill="#FFFFFF" />
                                </svg>
                                <svg v-else-if="item.status == 1 || item.status == 2" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                                        fill="#FFFFFF" />
                                </svg>
                                <svg v-else-if="item.status == 3" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                                <svg v-else-if="item.status == 4" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z"
                                        fill="white" />
                                </svg>
                            </template>
                        </StatusButton>
                    </td>
                    <td>
                        {{ item.comment }}
                    </td>
                </tr>
            </tbody>
        </v-table>
    </div>
    <v-dialog v-model="dialogCommentRefuse" v-if="dialogCommentRefuse">
        <v-card width="max-content" height="max-content" class="px-8 py-4">
            <div class="row justify-content-center">
                <v-card-title class="text-left">{{ $t("clients.validationTab.commentaireRefuser") }} :
                    <span class="red">*</span></v-card-title>
            </div>
            <div class="row justify-content-center">
                <v-textarea id="Comment" v-model="commentaireRefuse" variant="outlined" counter
                    :label="$t('clients.validationTab.commentaireLabel')" single-line auto-grow hide-details
                    maxlength="500"></v-textarea>
                <span class="warningHint" id="WarningMsgComment">{{
                    msg.refuseComment
                }}</span>
            </div>
            <div class="row justify-content-center">
                <card-actions :yes="RefuseCustomer" v-model:no="dialogCommentRefuse" width="200px"
                    :yesTitle="$t('clients.validationTab.refuseBtn')" :YesColor="'#F25C5C'" :loader="buttonLoader" />
            </div>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCommentToCorrect" v-if="dialogCommentToCorrect">
        <v-card width="max-content" height="max-content" class="px-8 py-4">
            <div class="row justify-content-center">
                <v-card-title class="text-left">{{ $t("clients.validationTab.commentaireToCorrect") }} :
                    <span class="red">*</span></v-card-title>
            </div>
            <div class="row justify-content-center mb-3">
                <v-textarea id="Comment" v-model="correctValues" variant="outlined" counter single-line auto-grow
                    hide-details maxlength="500"  ></v-textarea>
                    
            <div class="title">
                {{ $t('clients.validationTab.MessageSup') }}       </div>
                    <v-textarea id="Comment" v-model="correctValuesSupp" variant="outlined" counter single-line auto-grow
                    hide-details maxlength="500" ></v-textarea>
                <span class="warningHint" id="WarningMsgComment">{{
                    msg.toCorrectComment
                }}</span>
            </div>
            <div class="row justify-content-center">
                <card-actions :yes="ToCorrectCustomer" v-model:no="dialogCommentToCorrect" width="200px"
                    :yesTitle="$t('clients.validationTab.toCorrectBtn')" :YesColor="'#F25C5C'" :loader="buttonLoader"/>
            </div>
        </v-card>
    </v-dialog>
    <dialogDelete DialogType="Validation" :title="$t('clients.client')" :yes="ValideCustomer"
    v-model="dialogValidation" :loader="buttonLoader" />
</template>
<script>
import { ChangeStatusOfCustomerByid, GetTraceValidationListByClientId, getClientsById } from "@/api/index"
import StatusButton from "@/genericComponent/StatusButton.vue";
import CardActions from "@/genericComponent/cardActions.vue";
import DialogDelete from "@/genericComponent/dialogDelete.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
export default {
    components: { StatusButton, genericBtnComponent,CardActions,DialogDelete },
    data() {
        return {
            loader: true,
            Customer: null,
            idCustomer:null,
            Status: null,
            correctValues: "",
            correctValuesSupp: "",
            validationStatus: 3,
            refuseStatus: 4,
            toCorrectStatus: 1,
            afficheCommentaire: false,
            ShowChangeStatusValues: [1, 3, 4],
            commentaire: null,
            dialogValidation: false,
            dialogCommentRefuse: false,
            dialogCommentToCorrect:false,
            msg: [],
            buttonLoader: false,
            TraceValidationList: null
        };
    },
    created() {
        this.idCustomer = this.$route.params.id;
        this.getClientById(this.idCustomer);
        const values = JSON.parse(localStorage.getItem(`toCorrect//${this.idCustomer}`)) || [];
        if (values.length != 0) {
            let msg = "Please correct the following items and resubmit your data for verification : ";
            //this.isDisabled = false;
            this.correctValues = msg + values.map(item => item).join(', ');
        }
    },
    methods: {
        GetTraceValidationListByClientId: function (idCustomer) {
            GetTraceValidationListByClientId(idCustomer).then(({ data }) => {
                this.TraceValidationList = data
            })
        },
        getClientById: function (idCustomer) {
            getClientsById(idCustomer)
                .then(({ data }) => {
                    this.Customer = data;
                    this.Status = data.accountStatus
                    this.GetTraceValidationListByClientId(this.idCustomer);
                    this.loader = false;

                }).finally(() => {
                    this.buttonLoader = false;
                    this.$emit("getStatusSupplier");
                });
        },
        ValideCustomer() {
            this.buttonLoader = true;
            ChangeStatusOfCustomerByid(this.idCustomer, this.validationStatus).then(() => {
                this.getClientById(this.idCustomer);
                this.dialogValidation = false;
            }).finally(() => {
                this.buttonLoader = false;
            });
        },
        RefuseCustomer() {
            if (!this.commentaireRefuse) {
                this.msg.refuseComment = "Please provide a reason for the refusal";
            } else {
                this.buttonLoader = true;
                ChangeStatusOfCustomerByid(this.idCustomer, this.refuseStatus,this.commentaireRefuse)
                    .then(() => {
                        this.getClientById(this.idCustomer);
                        this.msg.refuseComment = "";
                        this.commentaire = null;
                        this.dialogCommentRefuse = false;
                    })
                    .catch(error => {
                        console.error("Error updating customer status:", error);
                    }).finally(() => {
                        this.buttonLoader = false;
                    });
            }
        },
        ToCorrectCustomer() {
            if (this.correctValues !== "") {
                this.correctValues= this.correctValues+'.   '+this.correctValuesSupp
                this.buttonLoader = true;
                ChangeStatusOfCustomerByid( this.idCustomer, this.toCorrectStatus,this.correctValues).then(() => {
                    this.getClientById(this.idCustomer);
                    localStorage.removeItem(`toCorrect//${this.idCustomer}`);
                    this.msg.toCorrectComment = "";
                    this.commentaire = null;
                    this.dialogCommentToCorrect = false;
                }).finally(() => {
                    this.buttonLoader = false;
                });
            } else {
                this.msg.toCorrectComment = "Please select one or more fields to correct before updating";
            }
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        statusTitle(option) {
            switch (option) {
                case 0: return this.$t('clients.statusList.created');
                case 1: return this.$t('clients.statusList.toCorrect');
                case 2: return this.$t('clients.statusList.toBeValidatedByAdmin');
                case 3: return this.$t('clients.statusList.validatedCustomer');
                case 4: return this.$t('clients.statusList.rejected');
                default: return this.$t('clients.statusList.toBeValidatedByAdmin');
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 0: return 'blue';   // Created
                case 1: return 'yellow'; // To Correct
                case 2: return 'orange'; // To be validated by admin
                case 3: return 'green';  // Validated Customer
                case 4: return 'red';    // Rejected
                default: return 'gray';   // Default color
            }
        },
    },

    computed: {
        statusText() {
            switch (this.Status) {
                case 0: return this.$t('clients.statusList.created');
                case 1: return this.$t('clients.statusList.toCorrect');
                case 2: return this.$t('clients.statusList.toBeValidatedByAdmin');
                case 3: return this.$t('clients.statusList.validatedCustomer');
                case 4: return this.$t('clients.statusList.rejected');
                default: return this.$t('clients.statusList.toBeValidatedByAdmin');
            }
        },
        formattedDateTime() {
            return item => {
                const date = new Date(item.validationDate + "Z");

                const options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                };

                const formattedDate = new Intl.DateTimeFormat('default', options).format(date);

                return formattedDate;
            }
        },
    }
};
</script>
<style>
.title-cadre {
    height: 40px;
    border-radius: 6px;
    background: var(--grays-gray-100, #F9FAFB);

}

.title {
    color: var(--accent-accent-black, #080C3E);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
}

.timelineStatus {
    display: flex;
    flex-direction: row;
    padding: auto;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.validationText {
    color: var(--Black, #1B194B);
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 0.5;
    margin-top: 20px;
}
</style>